<template>
	<layout-main>
		<template #toolbar>
			<layout-tool-bar :title="strings.title" />
		</template>

		<v-container fill-wh>
			<router-view />
		</v-container>

		<template #footer>
			<layout-footer @click:tab="navigate" />
		</template>
	</layout-main>
</template>

<script>
import strings from "@/utils/strings";

export default {
	data: () => ({
		strings: strings.dashboard,
	}),

	methods: {
		navigate(to) {
			if (to === "community" && this.$route.path !== "/dashboard")
				return this.$router.push({ path: "/dashboard" });
		},
	},
};
</script>
